'use strict';

var ngModule = 'frontend.auth';

require('angular')
  .module(ngModule, [])
  .factory('meService',   require('./service/me'))
  .factory('userService', require('./service/user'))
  .component('authLogin', require('./auth-login'))
  .component('authLogout', require('./auth-logout'))
  .component('authAccept', require('./auth-accept'))
  .component('setPassword', require('./set-password'))
  .component('forgotPassword', require('./forgot-password'))
  .provider('$role', require('./provider'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/index.js
 ** module id = 168
 ** module chunks = 0
 **/